import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "toast-stack",
  "aria-live": "polite",
  "aria-atomic": "false"
}
const _hoisted_2 = ["onClick"]

import { removeToast, ToastType, toasts } from "@/Shared/services/toastService";


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastContainer',
  setup(__props) {

function icon(type: ToastType) {
  return {
    success: "bi bi-check-circle",
    danger: "bi bi-exclamation-triangle",
    warning: "bi bi-hourglass-split",
  }[type];
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, { name: "toast" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (item) => {
            return (_openBlock(), _createElementBlock("article", {
              key: item.id,
              class: _normalizeClass(["app-toast", item.type])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(icon(item.type))
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(item.message), 1),
              _createElementVNode("button", {
                type: "button",
                title: "Fermer",
                onClick: ($event: any) => (_unref(removeToast)(item.id))
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
              ]), 8, _hoisted_2)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})